import React from "react";

export const SimpleTable: React.FC<{
  title: string;
  data: Record<string, string | number | boolean | number[] | null>;
}> = (props) => (
  <div style={{ marginBottom: 30 }}>
    <h2>{props.title}</h2>
    <table border={1} cellPadding={8}>
      <tbody>
        {Object.entries(props.data).map(([key, value]) => (
          <tr key={key}>
            <td>
              <strong>{key}</strong>
            </td>
            <td>{JSON.stringify(value)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
